const isProduction = process.env.NODE_ENV === 'production';

const production = {
    environment: {
        prod: true
    },
    production: true,
    payment: {
        paypal: {
            enabled: true,
            clientId: 'AQUjQQfluj-Vmy0-Iwt1udu8YWv5VJ94LBqsMCNW0tUBt9UmDzo17aHmWPvUbSwBO6XxOiZ0pnbLLm4I',
            plans: {
                threeDaysTrial_Monthly_SevenNinetyNine: 'P-2TD92134NS982942DL7QSAMQ',
                threeDaysTrial_SemiAnnual_FiveNinetyNine: 'P-25P77153XS664921RL7QSBOQ',
                threeDaysTrial_Annual_ThreeNinetyNine: 'P-1MH42961X8888901JL7QSCDI',
                Monthly_SevenNinetyNine:'P-3A78378837352211BL7QS3OY',
                SemiAnnual_FiveNinetyNine:'P-4B42675205096615DL7QS4DY',
                Annual_ThreeNinetyNine: 'P-0UU02905HD7941020L7QS4SA'
            }

        },
        stripe: {
            enabled: true,
            stripePublishableKey: 'pk_live_51Gz6HfCXsfUFsNcEakTHQbc3sdPfKp2eM1ETmdhhWSk0WE3Wud963Xpm6wy9XjhsYkrEj0nYL06hjwAkSDzoBNId00V7cvREtn',
            plans: {
                threeDaysTrial_Monthly_SevenNinetyNine: {planId: 'price_1J1bdpCXsfUFsNcEK4fJ1MaG', description: 'GameEnable $7.99 Monthly Subscription with 3 day trial', subscriptionDays: 30},
                threeDaysTrial_SemiAnnual_FiveNinetyNine: {planId: 'price_1J1bdlCXsfUFsNcEczoGsTD2', description: 'GameEnable $5.99 Semi-Annual Subscription with 3 day trial', subscriptionDays: 30 * 6},
                threeDaysTrial_Annual_ThreeNinetyNine: {planId: 'price_1J1aeHCXsfUFsNcEipLUblvx', description: 'GameEnable $3.99 Annual Subscription with 3 day trial', subscriptionDays: 365},
                Monthly_SevenNinetyNine: {planId:'price_1J1bdxCXsfUFsNcE59k2nEhm', description: 'GameEnable $7.99 Monthly Subscription with no trial', subscriptionDays: 30},
                SemiAnnual_FiveNinetyNine: {planId:'price_1J1bduCXsfUFsNcEw1O8sRX0', description: 'GameEnable $5.99 Semi-Annual with no trial', subscriptionDays: 30 * 6},
                Annual_ThreeNinetyNine: {planId:'price_1J1bdsCXsfUFsNcEg12R415F', description: 'GameEnable $3.99 Annual Subscription with no trial', subscriptionDays: 365},
            }
        }
    },

    serverURL: 'https://backend.gameenable.com'
};

const test = {
    production: false,
    payment: {
        paypal: {
            enabled: true,
            clientId: 'AVnraRYUCZjQPQZbR78QP1eTHWOAZFvFti8kofcMa9IWP7gGkQPV6pckrqPPOmMMtOApnkVM6zefQ9Cu',
            plans: {
                threeDaysTrial_Monthly_SevenNinetyNine: 'P-1WA338628E778841TL7QSHII',
                threeDaysTrial_SemiAnnual_FiveNinetyNine: 'P-1JX72419LH087441NL7QSJHQ',
                threeDaysTrial_Annual_ThreeNinetyNine: 'P-8TL76885PU9360323L7QSIKY',
                Monthly_SevenNinetyNine:'P-87R606003S159714TL7QS74Q',
                SemiAnnual_FiveNinetyNine:'P-57P96412SW5173610L7QTAJA',
                Annual_ThreeNinetyNine: 'P-6HJ16542MP295544YL7QTA2A'
            }

        },
        stripe: {
            enabled: true,
            stripePublishableKey: 'pk_test_51Gz6HfCXsfUFsNcEdjHObpCu9hv3AhXa5evXOjGDAcAKpxpcJUE3qe7KyDSJCRmZIcTRTWs21dNrw7xqoFCmEtAT006R84oEdY',
            plans: {
                threeDaysTrial_Monthly_SevenNinetyNine: {planId: 'price_1J1JFdCXsfUFsNcEYsU8ijw9', description: 'GameEnable $7.99 Monthly Subscription with 3 day trial', subscriptionDays: 30},
                threeDaysTrial_SemiAnnual_FiveNinetyNine: {planId: 'price_1J1a46CXsfUFsNcEutMetwXA', description: 'GameEnable $5.99 Semi-Annual Subscription with 3 day trial', subscriptionDays: 30 * 6},
                threeDaysTrial_Annual_ThreeNinetyNine: {planId: 'price_1J1a6yCXsfUFsNcERQ6q2GrB', description: 'GameEnable $3.99 Annual Subscription with 3 day trial', subscriptionDays: 365},
                Monthly_SevenNinetyNine: {planId:'price_1Iz8HnCXsfUFsNcEyor6m849', description: 'GameEnable $7.99 Monthly Subscription with no trial', subscriptionDays: 30},
                SemiAnnual_FiveNinetyNine: {planId:'price_1J1GotCXsfUFsNcEqAZmblc0', description: 'GameEnable $5.99 Semi-Annual with no trial', subscriptionDays: 30 * 6},
                Annual_ThreeNinetyNine: {planId:'price_1J1J0vCXsfUFsNcEYcHIyYYp', description: 'GameEnable $3.99 Annual Subscription with no trial', subscriptionDays: 365},
            }
        }

    },

    serverURL:'http://localhost:80'//'http://192.168.2.4:80'
};

export default isProduction? production : test;